import React from 'react';
import classnames from 'classnames';
import styles from './styles.scss';

const Feature = ({ feature: { name, description, icon } }) => {
  return (
    <div className={styles.feature}>
      <div className={styles.featureTitle}>
        <div className={styles.featureName}>
          <i className={classnames(icon, styles.featureIcon)} /> {name}
        </div>
      </div>
      <div className={styles.featureDescription}>{description}</div>
    </div>
  );
};

const GenericFeatures = ({ features }) => {
  return (
    <div className={styles.features}>
      {features.map((feature) => (
        <Feature key={feature.name} feature={feature} />
      ))}
    </div>
  );
};

export default GenericFeatures;
